import { render, staticRenderFns } from "./DeleteFieldMappingDialog.vue?vue&type=template&id=2da33ffe"
import script from "./DeleteFieldMappingDialog.vue?vue&type=script&lang=js"
export * from "./DeleteFieldMappingDialog.vue?vue&type=script&lang=js"
import style0 from "./DeleteFieldMappingDialog.vue?vue&type=style&index=0&id=2da33ffe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports